import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import EventGrid from "./EventGrid";

const DigitalEvents = ({ events = [] }) => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  if (!events || events.length === 0) return null;

  // Filter only digital events
  const digitalEvents = events.filter(
    (item) => item?.eventData?.isDigitalEvent === true
  );

  if (digitalEvents.length === 0) return null;

  return (
    <div className="max-w-[1300px] mx-auto px-0 py-2 relative">
      <EventGrid
        title={"Digital Events"}
        events={digitalEvents}
        limit={5}
        showViewAll={true}
      />
    </div>
  );
};

export default DigitalEvents;